import { emailRegexValidation, licenseNumberValidation } from '../../utils/validate';

const validate = (values) => {
  const errors = {};

  if (!emailRegexValidation(values.email)) {
    errors.email = 'required';
  }
  if (!values.password) {
    errors.password = 'required';
  }
  if (!values.repeat_password) {
    errors.repeat_password = 'required';
  }
  if (values.repeat_password && (values.repeat_password !== values.password)) {
    errors.repeat_password = 'passwordsDoNotMatch';
  }
  if (!values.phone) {
    errors.phone = 'required';
  }
  if (!values.first_name) {
    errors.first_name = 'required';
  }
  if (values.isAgentCheckbox) {
      if (!values.company_name) {
        errors.company_name = 'required';
      }
      if (!licenseNumberValidation(values.license_number)) {
        errors.license_number = 'licenseNumberLength';
      }
      if (!values.license_number) {
        errors.license_number = 'required';
      }
      if (values.license_number) {
        const isDigits = /^\d+$/.test(values.license_number);
        if (!isDigits) {
          errors.license_number = 'digitsOnly';
        }
      }
  }
  if (!values.agree) {
    errors.agree = 'emptyField';
  }
  return errors;
};

export default validate;
